import { TypoTooltip } from "@data-display/wrapper/DetectOverflow";
import type { ITypoTooltipProps } from "@data-display/wrapper/DetectOverflow/TypoTooltip";
import { Stack, type StackProps, type SvgIconTypeMap } from "@mui/material";
import type { OverridableComponent } from "@mui/material/OverridableComponent";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type React from "react";
import type { ReactNode } from "react";

export interface IIconInfoProps {
  Icon: OverridableComponent<SvgIconTypeMap<unknown, "svg">> & {
    muiName: string;
  };
  text: string | React.ReactNode;
  tooltip?: ReactNode;
  hidden?: boolean;
  className?: string;
  color?: SvgIconProps["color"];
  noWrap?: boolean;
  slotProps?: {
    stack?: Partial<StackProps>;
    icon?: Partial<SvgIconProps>;
    typography?: Partial<ITypoTooltipProps>;
  };
}

export const IconInfo = ({
  Icon,
  text,
  tooltip,
  hidden,
  className,
  color,
  noWrap,
  slotProps,
  ...props
}: IIconInfoProps) => {
  if (hidden) {
    return null;
  }

  return (
    <Stack
      direction="row"
      className={className}
      {...slotProps?.stack}
      {...props}
      sx={{
        alignItems: "start",
      }}
    >
      <Icon color={color ?? "secondary"} sx={{ fontSize: 17 }} {...slotProps?.icon} />
      <TypoTooltip
        tooltip={tooltip}
        variant="body1"
        lineHeight={1.2}
        paddingLeft={1}
        noWrap={noWrap}
        {...slotProps?.typography}
      >
        {text}
      </TypoTooltip>
    </Stack>
  );
};
